<h2 mat-dialog-title>Detalhe da execução</h2>

<mat-dialog-content>
  <!-- Resumo: os mesmos campos do histórico -->
  <div class="resumo">
    <div>
      <p class="campo-label">Data e hora</p>
      <p class="campo-valor">{{ execucao.datetimeInicio | date: 'dd/MM/yyyy HH:mm' }}</p>
    </div>
    <div>
      <p class="campo-label">Origem</p>
      <p class="campo-valor">
        {{ execucao.ibptOrigemExecucao === origemExecucaoEnum.Planilha ? 'Planilha' : 'API' }}
      </p>
    </div>
    <div>
      <p class="campo-label">Responsável</p>
      <p class="campo-valor">{{ execucao.nomeUsuarioAdmin ?? 'Sistema' }}</p>
    </div>
    <div>
      <p class="campo-label">Versão</p>
      <p class="campo-valor">{{ execucao.versao ?? '—' }}</p>
    </div>
    <div>
      <p class="campo-label">Resultado</p>
      <span
        class="chip-resultado"
        [class.chip-resultado-sucesso]="execucao.ibptResultadoExecucao === resultadoExecucaoEnum.Sucesso"
        [class.chip-resultado-sem-alteracao]="
          execucao.ibptResultadoExecucao === resultadoExecucaoEnum.SemAlteracao
        "
        [class.chip-resultado-falha]="execucao.ibptResultadoExecucao === resultadoExecucaoEnum.Falha"
        [class.chip-resultado-em-andamento]="
          execucao.ibptResultadoExecucao === resultadoExecucaoEnum.EmAndamento
        "
        [class.chip-resultado-cancelada]="execucao.ibptResultadoExecucao === resultadoExecucaoEnum.Cancelada">
        <span class="material-symbols-outlined">{{ iconeResultado(execucao.ibptResultadoExecucao) }}</span>
        {{ descricaoResultado(execucao.ibptResultadoExecucao) }}
      </span>
    </div>
    <div class="resumo-detalhe">
      <p class="campo-label">Detalhe</p>
      <p class="campo-valor">{{ data.detalhe }}</p>
    </div>
    <div>
      <p class="campo-label">Duração</p>
      <p class="campo-valor">{{ data.duracao }}</p>
    </div>
  </div>

  @if (execucao.ibptOrigemExecucao === origemExecucaoEnum.Api) {
    <section class="bloco">
      <h3 class="secao-titulo">Tentativas</h3>
      @if (data.detalheExecucao.listaTentativa.length > 0) {
        <div class="tabela-rolagem">
          <table mat-table [dataSource]="data.detalheExecucao.listaTentativa">
            <ng-container matColumnDef="numero">
              <th mat-header-cell *matHeaderCellDef>Tentativa</th>
              <td mat-cell *matCellDef="let tentativa">Tentativa {{ tentativa.numero }}</td>
            </ng-container>

            <ng-container matColumnDef="datetimeInicio">
              <th mat-header-cell *matHeaderCellDef>Início</th>
              <td mat-cell *matCellDef="let tentativa" class="sem-quebra">
                {{ tentativa.datetimeInicio | date: 'dd/MM/yyyy HH:mm:ss' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="datetimeFim">
              <th mat-header-cell *matHeaderCellDef>Fim</th>
              <td mat-cell *matCellDef="let tentativa" class="sem-quebra">
                {{ (tentativa.datetimeFim | date: 'dd/MM/yyyy HH:mm:ss') ?? '—' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="resultado">
              <th mat-header-cell *matHeaderCellDef>Resultado</th>
              <td mat-cell *matCellDef="let tentativa">
                {{ descricaoResultadoTentativa(tentativa) }}
                @if (tentativa.quantidadeItensErro > 0) {
                  · {{ tentativa.quantidadeItensErro | number }}
                  {{ tentativa.quantidadeItensErro === 1 ? 'item com erro' : 'itens com erro' }}
                }
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsTentativa"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsTentativa"></tr>
          </table>
        </div>
      } @else {
        <p class="texto-apoio">Nenhuma tentativa registrada.</p>
      }
    </section>
  } @else {
    <section class="bloco">
      <h3 class="secao-titulo">Arquivos</h3>
      <div class="arquivos-planilha">
        <div class="tabela-rolagem arquivos-tabela">
          <table mat-table [dataSource]="execucao.listaArquivo">
            <ng-container matColumnDef="nomeArquivo">
              <th mat-header-cell *matHeaderCellDef>Arquivo</th>
              <td mat-cell *matCellDef="let arquivo" class="quebra-texto">{{ arquivo.nomeArquivo }}</td>
            </ng-container>

            <ng-container matColumnDef="idUnidadeFederativa">
              <th mat-header-cell *matHeaderCellDef>UF</th>
              <td mat-cell *matCellDef="let arquivo">{{ siglaUf(arquivo.idUnidadeFederativa) }}</td>
            </ng-container>

            <ng-container matColumnDef="quantidadeLinhasValidas">
              <th mat-header-cell *matHeaderCellDef>Linhas válidas</th>
              <td mat-cell *matCellDef="let arquivo">{{ arquivo.quantidadeLinhasValidas | number }}</td>
            </ng-container>

            <ng-container matColumnDef="quantidadeLinhasRejeitadas">
              <th mat-header-cell *matHeaderCellDef>Linhas rejeitadas</th>
              <td mat-cell *matCellDef="let arquivo">{{ arquivo.quantidadeLinhasRejeitadas | number }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsArquivo"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsArquivo"></tr>
          </table>
        </div>
        <app-mapa-uf-ibpt class="arquivos-mapa" [situacaoPorUf]="situacaoPorUf"></app-mapa-uf-ibpt>
      </div>
      @if (execucao.isConfirmadoImportacao) {
        <p class="texto-apoio">Confirmação marcada pelo usuário</p>
      }
    </section>
  }

  <section class="bloco">
    <h3 class="secao-titulo">Logs da execução</h3>
    @if (data.detalheExecucao.listaLog.length > 0) {
      <div class="tabela-rolagem">
        <table mat-table [dataSource]="data.detalheExecucao.listaLog">
          <ng-container matColumnDef="idIbptExecucaoLog">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let log">{{ log.idIbptExecucaoLog }}</td>
          </ng-container>

          <ng-container matColumnDef="tipo">
            <th mat-header-cell *matHeaderCellDef>Tipo</th>
            <td mat-cell *matCellDef="let log">
              <span
                class="chip-situacao"
                [class.chip-erro]="log.idIbptTipoLogExecucao === tipoLogExecucaoEnum.Erro"
                [class.chip-sucesso]="log.idIbptTipoLogExecucao === tipoLogExecucaoEnum.Sucesso"
                [class.chip-alerta]="log.idIbptTipoLogExecucao === tipoLogExecucaoEnum.Aviso">
                {{ descricaoTipoLog(log.idIbptTipoLogExecucao) }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="funcao">
            <th mat-header-cell *matHeaderCellDef>Função</th>
            <td mat-cell *matCellDef="let log" class="quebra-texto">{{ log.funcao }}</td>
          </ng-container>

          <ng-container matColumnDef="mensagem">
            <th mat-header-cell *matHeaderCellDef>Mensagem</th>
            <td mat-cell *matCellDef="let log" class="quebra-texto">{{ log.mensagem }}</td>
          </ng-container>

          <ng-container matColumnDef="datetimeInclusao">
            <th mat-header-cell *matHeaderCellDef>Data</th>
            <td mat-cell *matCellDef="let log" class="sem-quebra">
              {{ log.datetimeInclusao | date: 'dd/MM/yyyy HH:mm:ss' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="acao">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let log">
              <!-- Olho só com o id do SRVLog; sem a permissão de listar logs fica desabilitado (padrão da tela). -->
              @if (log.idLog !== null) {
                <a
                  *appTemPermissao="permissaoEnum.Desenvolvedor_Logs_Listar"
                  mat-mini-fab
                  class="fab-action default"
                  matTooltip="Ver log"
                  aria-label="Ver log"
                  [routerLink]="['/desenvolvedor/logs/detalhe', { idLog: log.idLog }]"
                  (click)="fechar()">
                  <mat-icon>visibility</mat-icon>
                </a>
              }
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsLog"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsLog"></tr>
        </table>
      </div>
    } @else {
      <p class="texto-apoio">Nenhum log registrado.</p>
    }
  </section>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" mat-flat-button class="btn-secundary" (click)="fechar()">Fechar</button>
</mat-dialog-actions>
